// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"281":"d1df04af","637":"852d7b6d"}[chunkId] + ".css";
};